// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__EBl9L","metric":"Header_metric__IWovm"};